<div class="box">
  <div class="box-header">
    <div class="pull-left">
      <form class="form-inline">
        <div class="form-group">
          <label class="control-label">No. of entries</label>
        </div>
        <div class="form-group">
          <select
            style="display: inline;"
            #selectElem
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="page.size"
            (change)="staffs$.next({ offset: 0 })"
            >
            @for (size of coreService.sizeOptions; track size) {
              <option
                [value]="size"
                >{{ size }}</option
                >
              }
            </select>
          </div>
        </form>
      </div>

      <div class="pull-right">
        <button
          class="btn btn-sm btn-info btn-flat pull-left margin"
          style="margin-top: 0px;"
          (click)="resetFilters()"
          >
          Clear filters
        </button>
        @if (group == groupTypes.ADMIN) {
          <button
            style="margin-top: 0px;"
            class="btn btn-sm btn-info btn-flat pull-left margin"
            (click)="openModal('assign')"
            >
            Assign Staff
          </button>
        }
        @if (group == groupTypes.ADMIN || group == groupTypes.MANAGER) {
          <button
            style="margin-top: 0px;"
            class="btn btn-sm btn-info btn-flat pull-right margin"
            (click)="openModal('create')"
            >
            Create Staff
          </button>
        }
        <!-- <button
        *ngIf="group == groupTypes.ADMIN || group == groupTypes.MANAGER"
        style="margin-top: 0px;"
        class="btn btn-sm btn-info btn-flat pull-right margin"
        (click)="openModal('make')"
        >
        Make User Staff
      </button> -->
    </div>
  </div>
  <div class="box-body">
    <form [formGroup]="form">
      <ngx-datatable
        [externalSorting]="true"
        [cssClasses]="iconsCss"
        [loadingIndicator]="isLoading"
        class="material striped"
        [rows]="rows"
        [columnMode]="'force'"
        [headerHeight]="'auto'"
        [rowHeight]="'50'"
        [footerHeight]="50"
        [externalPaging]="true"
        [count]="page.totalElements"
        [offset]="page.pageNumber"
        (page)="staffs$.next($event)"
        (sort)="onSort($event)"
        [limit]="page.size"
        >
        <ngx-datatable-column
          [sortable]="false"
          prop="index"
          name="{{ 'Sr No' | uppercase }}"
          [flexGrow]="0.5"
          >
          <ng-template let-column="column" ngx-datatable-header-template>
            <p>{{ column.name }}</p>
          </ng-template>

          <ng-template
            let-row="row"
            let-rowIndex="rowIndex"
            let-value="value"
            ngx-datatable-cell-template
            >
            <strong>{{ page.size * page.pageNumber + rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="false"
          name="{{ 'Username' | uppercase }}"
          [flexGrow]="1"
          >
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
            >
            <p>{{ row.user_detail.email }}</p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="true"
          name="{{ 'Name' | uppercase }}"
          [flexGrow]="1"
          >
          <ng-template
            let-column="column"
            let-sort="sortFn"
            ngx-datatable-header-template
            >
            <p (click)="sort()" style="cursor: pointer;">
              {{ column.name }}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
            <input
              type="text"
              class="form-control input-sm"
              placeholder="Filter by {{ column.name | titlecase }}"
              formControlName="name"
              />
          </ng-template>

          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
            >
            <p>
              {{ row.user_detail.first_name }} {{ row.user_detail.last_name }}
            </p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="true"
          name="{{ 'Role' | uppercase }}"
          [flexGrow]="1"
          >
          <ng-template
            let-column="column"
            let-sort="sortFn"
            ngx-datatable-header-template
            >
            <p (click)="sort()" style="cursor: pointer;">
              {{ column.name }}
              <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
            </p>
          </ng-template>

          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
            >
            <p>{{ row.user_detail.user_type.join(', ') }}</p>
            <!-- <p>{{ row.user_detail.user_type[0] }}</p> -->
          </ng-template>
        </ngx-datatable-column>

        @if (group == groupTypes.ADMIN) {
          <ngx-datatable-column
            [sortable]="false"
            name="{{ 'Actions' | uppercase }}"
            [flexGrow]="1"
            >
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
              >
              @if (group == groupTypes.ADMIN) {
                <a
                  href="javascript:void(0);"
                  (click)="deleteParkingStaff(row.id)"
                  >
                  <i
                    aria-hidden="true"
                    class="fa fa-trash-o  fa-fw"
                    style="color:red; cursor: pointer;"
                  ></i>
                </a>
              }
              @if (group == groupTypes.ADMIN) {
                <a
                  href="javascript:void(0);"
                  (click)="openModal('password', row.user_detail)"
                  >
                  <i
                    class="fa fa-key fa-fw"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    title="Change password"
                    >
                  </i>
                </a>
              }
              @if (group == groupTypes.ADMIN) {
                <a
                  href="javascript:void(0);"
                  (click)="openModal('edit', row.user_detail)"
                  >
                  <i
                    class="fa fa-pencil-square-o fa-fw"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    title="Edit Staff"
                    >
                  </i>
                </a>
              }
            </ng-template>
          </ngx-datatable-column>
        }
      </ngx-datatable>
    </form>
  </div>
</div>
